import Popper from '@popperjs/core/dist/umd/popper.js';
import * as bootstrap from 'bootstrap'

// expose it for any code that looks for a global `bootstrap`
if (typeof window !== 'undefined') {
	window.bootstrap = bootstrap
}

import "./src/autosize"
import "./src/countup"
import "./src/input-mask"
import "./src/dropdown"
import "./src/tooltip"
import "./src/popover"
import "./src/switch-icon"
import "./src/tab"
import "./src/toast"
import './src/weblayout-helpers';
import './src/weblayout-navigation';
import Sidebar from './src/sidebar';
import Navigation from "./src/navigation"

export { bootstrap }
export * as atheox from "./src/atheox"
